<div class="card bg-white mb-3">
    <div class="card-body">
        <div class="row mt-3">
            <!-- Left Column -->
            <div class="col-md-6">
                <!-- Study Name -->
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label fw-bold">
                        {{ 'study-editor.basic-details.studyName' | translate }}
                        <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                    </label>
                    <div class="col-sm-8">
                        <input type="text"
                               class="form-control"
                               [(ngModel)]="basicDetails.name"
                               (ngModelChange)="triggerAutoSave('name', basicDetails.name)"
                               maxlength="225"
                               [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)">
                    </div>
                </div>

                <!-- Description -->
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label fw-bold">
                        {{ 'study-editor.basic-details.description' | translate }}
                        <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                    </label>
                    <div class="col-sm-8">
                        <input type="text"
                               class="form-control"
                               [(ngModel)]="basicDetails.description"
                               (ngModelChange)="triggerAutoSave('description', basicDetails.description)"
                               maxlength="225"
                               [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)">
                    </div>
                </div>

                <!-- Study Type -->
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label fw-bold">
                        {{ 'study-editor.basic-details.studyType' | translate }}
                        <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                    </label>
                    <div class="col-sm-8">
                        <ng-container>
                            <span>{{ getStudyType(basicDetails?.studyType) | translate }}</span>
                        </ng-container>
                    </div>
                </div>

                <!-- Objective -->
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label fw-bold">
                        {{ 'study-editor.basic-details.objective' | translate }}
                    </label>
                    <div class="col-sm-8">
                        <textarea class="form-control"
                                  rows="3"
                                  [(ngModel)]="basicDetails.objective"
                                  (ngModelChange)="triggerAutoSave('objective', basicDetails.objective)"
                                  maxlength="255"
                                  [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)">
                        </textarea>
                    </div>
                </div>
            </div>

            <!-- Right Column -->
            <div class="col-md-6">
                <!-- Save in -->
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label fw-bold">
                        {{ 'study-editor.basic-details.saveIn' | translate }}
                        <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input readonly type="text" class="form-control"
                                   [(ngModel)]="basicDetails.parentFolderName" (click)="changeFolderLocation()">
                            <button class="btn btn-outline-secondary" (click)="changeFolderLocation()"
                                    *ngIf="hasAnyAuthority(STUDY_FOLDER_ACTIONS_CHANGE_PERMISSIONS)">
                                {{ 'study-editor.basic-details.changeFolder' | translate }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Created by -->
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label fw-bold">
                        {{ 'study-editor.basic-details.createdBy' | translate }}
                        <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                    </label>
                    <div class="col-sm-8">
                        <span>{{ basicDetails.createdByName }}</span>
                    </div>
                </div>

                <!-- Creation date -->
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label fw-bold">
                        {{ 'study-editor.basic-details.creationDate' | translate }}
                        <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control w-50"
                                   [placeholder]="'global.date.placeholder' | translate"
                                   [(ngModel)]="basicDetails.startDate"
                                   (ngModelChange)="triggerAutoSave('startDate', basicDetails.startDate)"
                                   [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)"
                                   ngbDatepicker [autoClose]="true" #startDate="ngbDatepicker">
                            <button class="btn btn-outline-secondary calendar" (click)="startDate.toggle()"
                                    type="button"><i class="fa fa-calendar"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Completion date -->
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label fw-bold">
                        {{ 'study-editor.basic-details.completionDate' | translate }}
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control w-50"
                                   [placeholder]="'global.date.placeholder' | translate"
                                   [(ngModel)]="basicDetails.endDate"
                                   (ngModelChange)="triggerAutoSave('endDate', basicDetails.endDate)"
                                   [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)"
                                   ngbDatepicker [autoClose]="true" #endDate="ngbDatepicker">
                            <button class="btn btn-outline-secondary calendar" (click)="endDate.toggle()"
                                    type="button"><i class="fa fa-calendar"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
